
import { Route, Routes, useLocation } from 'react-router-dom';

import Backup from './backup/backup';
import Logout from './logout';
import PremiumOptions from './premium/premiumOptions';
import Profile from './profile';
import SyncMain from './sync/syncMain';
import ViewSync from './sync/viewSync';
import ConnectedAcccounts from './transfer/connectedAcccounts';
import EditTransfer from './transfer/history/editTransfer';
import TransferHistory from './transfer/history/transferHistory';
import CompleteManualTransfer from './transfer/manual/completeManualTransfer';
import NotFoundInDashboard from './../notFound/notFoundInDashboard';



export default function Main() {

  const location = useLocation();



  return (
  <>
      <Routes>

        <Route path='*' element={<NotFoundInDashboard/>} />

        <Route path='/accounts' element={<ConnectedAcccounts />} ></Route>
        <Route path='/transferHistory' element={<TransferHistory />} ></Route>
        <Route path='/transferHistory/:transferId/edit' element={<EditTransfer />} ></Route>
        <Route path='/transferHistory/:transferId/complete' element={<CompleteManualTransfer />} ></Route>


        <Route path='/sync' element={<SyncMain />} ></Route>
        <Route path='/sync/:syncId' element={<ViewSync />} ></Route>


        <Route path='/profile' element={<Profile />} ></Route>
        <Route path='/backups' element={<Backup />} ></Route>
        <Route path='/premium' element={<PremiumOptions />} ></Route>
        <Route path='/logout' element={<Logout />} ></Route>
      </Routes>
            
{/*       
      <Copyright sx={{ pt: 4 }} /> */}
    </>

  )
}